import { useState } from 'react'

const BookHoverHandler = ({ setShowModal = () => {} }) => {
    const [delayHandler, setDelayHandler] = useState(null);

    const handleMouseEnter = () => {
        setDelayHandler(setTimeout(() => {
            setShowModal(true)
        }, 2000))
    }

    const handleMouseLeave = () => {
        clearTimeout(delayHandler)
    }

    const handleClick = () => {
        setShowModal(true);
        clearTimeout(delayHandler);
    }

    return (
        <button 
            className="absolute left-0 top-0 w-full h-full opacity-0 group-hover:opacity-100 bg-white z-10 flex justify-center items-center p-10 text-center cursor-pointer"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
        >
            <h2>Hover for 2 seconds or click to display more info about the book</h2>
        </button>
    )
}

export default BookHoverHandler